module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.component_class,
    style: (_vm.component_style),
    on: {
      "click": _vm.backTop
    }
  }, [_vm._t("default", [_c('Icon', {
    attrs: {
      "name": "up"
    }
  })])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2356995e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackTop/BackTop.vue
// module id = 624
// module chunks = 0